import {css, cx} from "@panda/css";

import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import {replaceDigitsWithZeros} from "../../utils/replace_digits_with_zeros";
import {InfoIconWithPopover} from "./InfoIconWithPopover";

export enum MainDataType {
    PERCENT,
    COMMISSION,
    INSTALLMENT,
    RRSO
}

export interface IMainDataProps {
    interestPercent: number;
    isFixedRate: boolean;
    commission: number;
    equalInstallmentRate: number;
    rrso: number;
    shouldBlur?: boolean;
}

export const CreditOfferBoxMainData = (props: IMainDataProps) => {
    const {interestPercent, isFixedRate, commission, equalInstallmentRate, rrso, shouldBlur = false} = props;

    const getDisplayValue = (value: number, options: {precision: number; unit: string; unitZero: string}): string => {
        const formatted = numberFormat(value, options) ?? "";
        return shouldBlur ? replaceDigitsWithZeros(formatted) : formatted;
    };

    const getDisplayInstallment = (value: number): string => {
        const formatted = `${Math.round(value)} zł`;
        return shouldBlur ? replaceDigitsWithZeros(formatted) : formatted;
    };

    return (
        <div className={mainDataWrapperStyle}>
            <div className={mainDataHolderStyle}>
                <div className={labelWrapperStyle}>
                    <Text variant="body_copy_2" color="var(--colors-gray-600)" className={labelMarginStyle}>
                        Oprocentowanie
                    </Text>
                    <InfoIconWithPopover type={MainDataType.PERCENT} />
                </div>
                <Text as="p" variant="headline_2" className={cx(dataTextStyle, shouldBlur && blurredStyle)}>
                    {interestPercent > 0 ? getDisplayValue(interestPercent, {precision: 2, unit: "%", unitZero: "0%"}) : "-"}
                    <Text as="span" variant="info_txt_2" strong className={badgeStyle}>
                        {isFixedRate ? "Stałe" : "Zmienne"}
                    </Text>
                </Text>
            </div>

            <div className={mainDataHolderStyle}>
                <div className={labelWrapperStyle}>
                    <Text variant="body_copy_2" color="var(--colors-gray-600)" className={labelMarginStyle}>
                        RRSO
                    </Text>

                    <InfoIconWithPopover type={MainDataType.RRSO} />
                </div>
                <Text as="p" variant="headline_2" className={cx(dataTextStyle, shouldBlur && blurredStyle)}>
                    {getDisplayValue(rrso, {precision: 2, unit: "%", unitZero: "0%"})}
                </Text>
            </div>

            <div className={mainDataHolderStyle}>
                <div className={labelWrapperStyle}>
                    <Text variant="body_copy_2" color="var(--colors-gray-600)" className={labelMarginStyle}>
                        Prowizja
                    </Text>

                    <InfoIconWithPopover type={MainDataType.COMMISSION} />
                </div>
                <Text as="p" variant="headline_2" className={cx(dataTextStyle, shouldBlur && blurredStyle)}>
                    {getDisplayValue(commission, {precision: 2, unit: "%", unitZero: "0%"})}
                </Text>
            </div>

            <div className={mainDataHolderStyle}>
                <div className={labelWrapperStyle}>
                    <Text variant="body_copy_2" color="var(--colors-gray-600)" className={labelMarginStyle}>
                        Rata miesięczna
                    </Text>

                    <InfoIconWithPopover type={MainDataType.INSTALLMENT} />
                </div>
                <Text as="p" variant="headline_2" className={cx(dataTextStyle, shouldBlur && blurredStyle)}>
                    <Highlight>
                        {shouldBlur ? (
                            getDisplayInstallment(equalInstallmentRate)
                        ) : (
                            <>
                                {Math.round(equalInstallmentRate)}{" "}
                                <Text as="span" variant="headline_6">
                                    zł
                                </Text>
                            </>
                        )}
                    </Highlight>
                </Text>
            </div>
        </div>
    );
};

const mainDataWrapperStyle = css({
    display: "flex",
    alignItems: "start",
    justifyContent: "space-evenly",
    flexDirection: "column",
    marginBottom: 2,
    md: {
        flexDirection: "row"
    },
    "& > div:last-child": {
        borderBottom: "unset",
        borderRight: "unset"
    }
});

const dataTextStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    minWidth: "130px"
});

const mainDataHolderStyle = css({
    display: "flex",
    alignItems: "end",
    justifyContent: "space-between",
    width: "100%",
    borderBottom: "1px solid var(--colors-gray-500)",
    paddingTop: 1,
    paddingBottom: 1,
    md: {
        display: "flex",
        alignItems: "start",
        justifyContent: "space-between",
        flexDirection: "column",
        width: "25%",
        marginRight: 3,
        borderRight: "1px solid var(--colors-gray-500)",
        borderBottom: "unset"
    }
});

const labelWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    flexDirection: "row",
    marginBottom: 0.5
});

const labelMarginStyle = css({
    marginRight: 0.5
});

const badgeStyle = css({
    paddingLeft: 2,
    paddingRight: 2
});

const blurredStyle = css({
    filter: "blur(6px)",
    userSelect: "none"
});
import {css, cx} from "@panda/css";

import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import {replaceDigitsWithZeros} from "../../utils/replace_digits_with_zeros";
import {InfoIconWithPopover} from "./InfoIconWithPopover";

export enum MainDataType {
    PERCENT,
    COMMISSION,
    INSTALLMENT,
    RRSO
}

export interface IMainDataProps {
    interestPercent: number;
    isFixedRate: boolean;
    commission: number;
    equalInstallmentRate: number;
    rrso: number;
    shouldBlur?: boolean;
}

export const CreditOfferBoxMainData = (props: IMainDataProps) => {
    const {interestPercent, isFixedRate, commission, equalInstallmentRate, rrso, shouldBlur = false} = props;

    const getDisplayValue = (value: number, options: {precision: number; unit: string; unitZero: string}): string => {
        const formatted = numberFormat(value, options) ?? "";
        return shouldBlur ? replaceDigitsWithZeros(formatted) : formatted;
    };

    const getDisplayInstallment = (value: number): string => {
        const formatted = `${Math.round(value)} zł`;
        return shouldBlur ? replaceDigitsWithZeros(formatted) : formatted;
    };

    return (
        <div className={mainDataWrapperStyle}>
            <div className={mainDataHolderStyle}>
                <div className={labelWrapperStyle}>
                    <Text variant="body_copy_2" color="var(--colors-gray-600)" className={labelMarginStyle}>
                        Oprocentowanie
                    </Text>
                    <InfoIconWithPopover type={MainDataType.PERCENT} />
                </div>
                <Text as="p" variant="headline_2" className={cx(dataTextStyle, shouldBlur && blurredStyle)}>
                    {interestPercent > 0 ? getDisplayValue(interestPercent, {precision: 2, unit: "%", unitZero: "0%"}) : "-"}
                    <Text as="span" variant="info_txt_2" strong className={badgeStyle}>
                        {isFixedRate ? "Stałe" : "Zmienne"}
                    </Text>
                </Text>
            </div>

            <div className={mainDataHolderStyle}>
                <div className={labelWrapperStyle}>
                    <Text variant="body_copy_2" color="var(--colors-gray-600)" className={labelMarginStyle}>
                        RRSO
                    </Text>

                    <InfoIconWithPopover type={MainDataType.RRSO} />
                </div>
                <Text as="p" variant="headline_2" className={cx(dataTextStyle, shouldBlur && blurredStyle)}>
                    {getDisplayValue(rrso, {precision: 2, unit: "%", unitZero: "0%"})}
                </Text>
            </div>

            <div className={mainDataHolderStyle}>
                <div className={labelWrapperStyle}>
                    <Text variant="body_copy_2" color="var(--colors-gray-600)" className={labelMarginStyle}>
                        Prowizja
                    </Text>

                    <InfoIconWithPopover type={MainDataType.COMMISSION} />
                </div>
                <Text as="p" variant="headline_2" className={cx(dataTextStyle, shouldBlur && blurredStyle)}>
                    {getDisplayValue(commission, {precision: 2, unit: "%", unitZero: "0%"})}
                </Text>
            </div>

            <div className={mainDataHolderStyle}>
                <div className={labelWrapperStyle}>
                    <Text variant="body_copy_2" color="var(--colors-gray-600)" className={labelMarginStyle}>
                        Rata miesięczna
                    </Text>

                    <InfoIconWithPopover type={MainDataType.INSTALLMENT} />
                </div>
                <Text as="p" variant="headline_2" className={cx(dataTextStyle, shouldBlur && blurredStyle)}>
                    <Highlight>
                        {shouldBlur ? (
                            getDisplayInstallment(equalInstallmentRate)
                        ) : (
                            <>
                                {Math.round(equalInstallmentRate)}{" "}
                                <Text as="span" variant="headline_6">
                                    zł
                                </Text>
                            </>
                        )}
                    </Highlight>
                </Text>
            </div>
        </div>
    );
};

const mainDataWrapperStyle = css({
    display: "flex",
    alignItems: "start",
    justifyContent: "space-evenly",
    flexDirection: "column",
    marginBottom: 2,
    md: {
        flexDirection: "row"
    },
    "& > div:last-child": {
        borderBottom: "unset",
        borderRight: "unset"
    }
});

const dataTextStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    minWidth: "130px"
});

const mainDataHolderStyle = css({
    display: "flex",
    alignItems: "end",
    justifyContent: "space-between",
    width: "100%",
    borderBottom: "1px solid var(--colors-gray-500)",
    paddingTop: 1,
    paddingBottom: 1,
    md: {
        display: "flex",
        alignItems: "start",
        justifyContent: "space-between",
        flexDirection: "column",
        width: "25%",
        marginRight: 3,
        borderRight: "1px solid var(--colors-gray-500)",
        borderBottom: "unset"
    }
});

const labelWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    flexDirection: "row",
    marginBottom: 0.5
});

const labelMarginStyle = css({
    marginRight: 0.5
});

const badgeStyle = css({
    paddingLeft: 2,
    paddingRight: 2
});

const blurredStyle = css({
    filter: "blur(6px)",
    userSelect: "none"
});
